export {default} from './Banner';
